module.exports = __webpack_public_path__ + "img/feedback.e7776c51.svg";